export const availableCars = [
  {
    id: '1',
    badge: 'جديدة',
    badgeColor: 'green',
    image: '/image/12.png',
    category: 'سيارة سيدان',
    name: 'تويوتا كورولا 2022',
    price: '150',
    year: '2022',
    transmission: 'اوتوماتيك',
    fuel: 'بنزين',
    passengers: '5 أشخاص',
  },
  {
    id: '2',
    badge: 'خصم خاص',
    badgeColor: 'red',
    image: '/image/13.png',
    category: 'سيارة عائلية',
    name: 'تويوتا كورولا كروس 2022',
    price: '150',
    year: '2022',
    transmission: 'اوتوماتيك',
    fuel: 'بنزين',
    passengers: '5 أشخاص',
  },
  {
    id: '3',
    badge: 'جديدة',
    badgeColor: 'green',
    image: '/image/14.png',
    category: 'سيارة SUV',
    name: 'تويوتا رايز 2023',
    price: '150',
    year: '2023',
    transmission: 'اوتوماتيك',
    fuel: 'بنزين',
    passengers: '5 أشخاص',
  },
  {
    id: '4',
    badge: 'مميز',
    badgeColor: 'red',
    image: '/image/12.png',
    category: 'سيارة سيدان',
    name: 'بي ام دبليو 2022',
    price: '700',
    year: '2022',
    transmission: 'اوتوماتيك',
    fuel: 'بنزين',
    passengers: '5 أشخاص',
  },
  {
    id: '5',
    badge: 'جديدة',
    badgeColor: 'green',
    image: '/image/13.png',
    category: 'سيارة رياضية',
    name: 'كيا سبورتاج 2022',
    price: '400',
    year: '2022',
    transmission: 'اوتوماتيك',
    fuel: 'بنزين',
    passengers: '5 أشخاص',
  },
  {
    id: '6',
    badge: 'مميز',
    badgeColor: 'red',
    image: '/image/14.png',
    category: 'سيارة فاخرة',
    name: 'مرسيدس C200 - موديل 2021',
    price: '600',
    year: '2021',
    transmission: 'اوتوماتيك',
    fuel: 'بنزين',
    passengers: '5 أشخاص',
  },
];

const carDetails = {
  '1': {
    id: '1',
    breadcrumbs: ['الرئيسية', 'تأجير سيارات', 'تويوتا كورولا 2022'],
    rating: 5,
    reviewCount: 4.9,
    category: 'اقتصادية',
    title: 'تويوتا كورولا 2022',
    gallery: ['/image/12.png', '/image/13.png', '/image/14.png', '/image/12.png', '/image/13.png', '/image/14.png'],
    reportText: 'الإبلاغ عن السيارة',
    views: '320',
    publishedAt: '22/02/2024',
    price: '6,000',
    priceUnit: 'شهرياً',
    status: 'متاحة',
    description:
      'سيارة عملية واقتصادية مناسبة للتنقل اليومي ورحلات العمل داخل المدينة. توفر المقصورة الداخلية راحة جيدة مع مساحة مناسبة للركاب وتجهيزات حديثة تمنح تجربة قيادة هادئة وسلسة.',
    basicSpecs: [
      ['الماركة', 'Toyota'],
      ['الموديل', 'Corolla 2022'],
      ['نوع الهيكل', 'Sedan'],
      ['عدد الأبواب', '4 أبواب'],
      ['عدد المقاعد', '5 ركاب'],
      ['نوع ناقل الحركة', 'اوتوماتيك'],
      ['نوع الوقود', 'بنزين'],
      ['اللون الخارجي', 'فضي'],
    ],
    technicalSpecs: [
      { label: 'المحرك', value: '1600 CC', icon: 'engine' },
      { label: 'القوة', value: '121 حصان', icon: 'bolt' },
      { label: 'استهلاك الوقود', value: '18.4 كم/لتر', icon: 'gauge' },
      { label: 'نظام الدفع', value: 'دفع أمامي', icon: 'drive' },
      { label: 'السرعة القصوى', value: '180 كم/س', icon: 'speed' },
      { label: 'مكيف الهواء', value: 'أوتوماتيك', icon: 'snow' },
    ],
    bookingPlans: {
      daily: {
        label: 'يومياً',
        price: '250',
        unit: 'يومياً',
        totalLabel: 'إجمالي الليلة الواحدة',
        total: '250 ريال',
      },
      monthly: {
        label: 'شهرياً',
        price: '6,000',
        unit: 'شهرياً',
        totalLabel: 'إجمالي الشهر الواحد',
        total: '6,000 ريال',
      },
      yearly: {
        label: 'سنوياً',
        price: '68,000',
        unit: 'سنوياً',
        totalLabel: 'إجمالي السنة الواحدة',
        total: '68,000 ريال',
      },
    },
    features: [
      'استهلاك اقتصادي ممتاز للوقود',
      'نظام تثبيت سرعة',
      'شاشة معلومات وترفيه',
      'كاميرا خلفية',
      'حساسات خلفية',
      'مكيف هواء أوتوماتيك',
      'مقاعد مريحة للرحلات الطويلة',
      'فتحات USB متعددة',
    ],
    reviews: [
      {
        id: 1,
        name: 'مصطفى التميمي',
        role: 'عميل',
        score: 4.9,
        comment: 'السيارة نظيفة جدًا والتسليم كان سريع. مناسبة جدًا للاستخدام اليومي داخل المدينة.',
      },
      {
        id: 2,
        name: 'سالم القرني',
        role: 'عميل',
        score: 4.9,
        comment: 'التجربة ممتازة من الحجز حتى الاستلام، والسيارة مريحة واستهلاكها اقتصادي.',
      },
    ],
    similarCars: ['4', '2', '3'],
  },
};

export function getCarDetails(carId) {
  return carDetails[carId] || carDetails['1'];
}

export function getSimilarCars(ids) {
  return ids
    .map((id) => availableCars.find((car) => car.id === id))
    .filter(Boolean);
}
